import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';
const Localization = (props) => {
    const { t, i18n } = useTranslation();
    const locales = {
        en: { title: "English" },
        as: { title: "অসমীয়া" }
    }
    return (
        <select className="getstarted scrollto" onChange={(e) => i18n.changeLanguage(e.target.value)} style={{bottom: 0}}>
            {Object.keys(locales).map((locale) => (
                <option key={locale}
                    data-icon="glyphicon-music"
                    type='submit'
                    selected={i18n.resolvedLanguage === locale}
                    value={locale}>
                    {locales[locale].title}
                </option>
            ))}
        </select>
    //     <FormControl fullWidth>
    //     <Select
    //       onChange={(e) => i18n.changeLanguage(e.target.value)}
    //       >
    //       {Object.keys(locales).map((locale) => <MenuItem key={locale} value={locale}>{locales[locale].title}</MenuItem>)}
    //     </Select>
    //   </FormControl>
    )
}
export default Localization